// extracted by mini-css-extract-plugin
export default {"companyInfo":"IedrRTocHoXEwkurCO6D","contactInfo":"Y8TVT5FvSaIzUZLMRsYx","legalLinks":"dYEmJQg5OWkjL9014W_d"};